<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <div class="footer-logo">
          <img v-if="storeInfo?.logo_url" :src="storeInfo.logo_url" :alt="storeInfo?.name || 'Logo'">
          <img v-else src="@/assets/img/default-logo.png" alt="Logo">
          <p>服務時間: Mon-Fri / 09:30 - 18:00<br>客服電話: 02-2515-0131</p>
        </div>
        <div class="footer-links">
          <div class="footer-col">
            <h4>分類</h4>
            <ul>
              <li v-for="category in mainCategories" :key="category">
                <a :href="'#'">{{ category }}</a>
              </li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>其他</h4>
            <ul>
              <li><a href="/products">SALE</a></li>
              <li><a href="/">最新消息</a></li>
              <li><a href="/about">關於我們</a></li>
              <li><a href="/privacy-policy">服務條款及隱私權政策</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="social-text">
          <p>快來追蹤我們！取得第一手消息！</p>
          <p>We want to hear from you!</p>
        </div>
        <div class="social-icons">
          <a href="#"><img src="@/assets/img/icon-facebook.svg" alt="facebook"></a>
          <a href="#"><img src="@/assets/img/icon-pinterest.svg" alt="pinterest"></a>
          <a href="#"><img src="@/assets/img/icon-youtube.svg" alt="youtube"></a>
          <a href="#"><img src="@/assets/img/icon-instagram.svg" alt="instagram"></a>
        </div>
      </div>

      <div class="footer-copy">
        <p>2025 {{ storeInfo?.name }} . All rights reserved</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState(['categories', 'storeInfo']),
    mainCategories() {
      if (!Array.isArray(this.categories)) {
        return []
      }
      return this.categories
        .filter(category => category.name !== 'SALE')
        .map(category => category.name)
    }
  }
}
</script> 

<style scoped>
.footer {
    background-color: #ffffff;
    border-top: 1px solid #e0e0e0;
    padding: 3rem 1rem 1rem;
    font-family: 'Noto Sans TC', sans-serif;
    color: #333;
}

.footer .footer-container {
    max-width: 1200px;
    margin: 0 auto;
}

.footer .footer-top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 2rem;
    margin-bottom: 2rem;
}

.footer .footer-logo {
    flex: 1;
    min-width: 250px;
}

.footer .footer-logo img {
    width: 150px;
    margin-bottom: 1rem;
}

.footer .footer-logo p {
    font-size: 0.9rem;
    color: #999;
    line-height: 1.5;
}

.footer .footer-links {
    display: flex;
    flex: 2;
    gap: 10rem;
    flex-wrap: wrap;
}

.footer .footer-col h4 {
    font-size: 1rem;
    font-weight: 700;
    color: #999;
    margin-bottom: 0.8rem;
}

.footer .footer-col ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer .footer-col ul li {
    margin-bottom: 0.5rem;
}

.footer .footer-col ul li a {
    text-decoration: none;
    color: #333;
    font-size: 1rem;
    font-weight: 400;
    transition: color 0.3s;
}

.footer .footer-col ul li a:hover {
    color: #F99393;
}

.footer .subscribe-form {
    display: flex;
    flex-direction: column;
}

.footer .subscribe-form input[type="email"] {
    border: none;
    border-bottom: 1px solid #aaa;
    padding: 0.5rem 0;
    font-size: 1rem;
    margin-bottom: 1rem;
    outline: none;
    background: transparent;
}

.footer .subscribe-form button {
    align-self: flex-start;
    background-color: #fff;
    border: 1px solid #F99393;
    color: #F99393;
    padding: 0.3rem 1.2rem;
    border-radius: 999px;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.3s ease;
}

.footer .subscribe-form button:hover {
    background-color: #F99393;
    color: #fff;
}

.footer .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    border-top: 1px solid #eee;
    padding-top: 1rem;
}

.footer .social-text p {
    font-size: 0.9rem;
    margin: 0.3rem 0;
}

.footer .social-icons {
    display: flex;
    gap: 1rem;
}

.footer .social-icons a {
    display: inline-block;
}

.footer .social-icons img {
    width: 20px;
    height: 20px;
}

.footer .footer-copy {
    text-align: center;
    font-size: 0.8rem;
    color: #999;
    margin-top: 1.5rem;
}
</style>